// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Qz7DP","spinning":"Spinner_spinning__Q1MzW","loadingText":"Spinner_loadingText__H9PRY"};